import toast from "react-hot-toast"

const apiClient = async (endpoint, method = "GET", body = null) => {
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      "Accept-Encoding": "identity",
      "Cache-Control": "no-cache, no-store, must-revalidate", // No caching at all
      Pragma: "no-cache", // Older HTTP/1.0 servers
      Expires: "0", // Ensures the response is always fresh
    },
  }

  if (body) {
    options.body = JSON.stringify(body)
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
      options
    )

    if (!response.ok) {
      const errorData = await response.json()
      const errorMessage =
        errorData.message || `HTTP error! Status: ${response.status}`
      throw new Error(errorMessage)
    }

    return await response.json()
  } catch (error) {
    const message = error.message || "An unexpected error occurred."
    toast.error(message, {
      duration: 5000,
    })
    console.error("API call failed:", error)
    throw error // rethrow if you want further handling upstream
  }
}

export const get = (endpoint) => apiClient(endpoint, "GET")
export const post = (endpoint, body) => apiClient(endpoint, "POST", body)
export const put = (endpoint, body) => apiClient(endpoint, "PUT", body)
